var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComdinheiro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.43081 4.53749C2.32002 8.59145 2.55555 12.2224 2.49521 12.7778C3.09344 14.4991 4.35219 15.6385 5.73098 16.9557C5.10665 16.2654 4.67416 15.4236 4.47664 14.514C4.27912 13.6045 4.32346 12.6591 4.60524 11.7721C5.55385 8.14764 11.5342 4.57902 16.904 2.44044C17.0775 2.37198 17.2321 2.26307 17.355 2.12279C17.4779 1.98251 17.5656 1.8149 17.6106 1.63392L17.9999 0.0436179C14.6496 1.17259 11.4391 2.6803 8.43081 4.53749Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.182165 8.93149C-0.501714 11.2576 0.80375 13.851 3.02993 16.5346C3.13942 16.6668 3.27671 16.7733 3.43204 16.8464C3.58736 16.9195 3.7569 16.9575 3.92858 16.9577H5.7317C4.35356 15.6412 2.91054 13.9808 2.3123 12.2594C1.93812 11.3835 1.8498 10.412 2.05991 9.48299C2.49074 8.01726 4.32047 6.19662 8.43283 4.53948C11.4406 2.68171 14.6504 1.17293 18 0.0423584V0.0618228C7.80605 1.87144 1.39355 4.81263 0.183462 8.92953L0.182165 8.93149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComdinheiro);
export default __webpack_public_path__ + "static/media/Comdinheiro.18c7968fb82079d102b2af0d52f0d511.svg";
export { ForwardRef as ReactComponent };